import { Link, useLocation } from 'react-router-dom';
import { IoHomeOutline, IoPersonOutline, IoLibraryOutline, IoConstructOutline, IoCallOutline } from 'react-icons/io5';
import './header.css';
import logo from "./logoimage/logo192.png";

const NAV_ITEMS = [
    { to: '/home', label: 'Home', Icon: IoHomeOutline, isActive: (p) => p === '/' || p === '/home' },
    { to: '/profile', label: 'About me!', Icon: IoPersonOutline, isActive: (p) => p === '/profile' },
    { to: '/experience', label: 'Experience', Icon: IoLibraryOutline, isActive: (p) => p === '/experience' },
    { to: '/projects', label: 'My projects', Icon: IoConstructOutline, isActive: (p) => p.startsWith('/projects') },
    { to: '/contact', label: 'Contact', Icon: IoCallOutline, isActive: (p) => p === '/contact' },
];

export const Header = () => {
    const location = useLocation();
    // Strip any trailing slash but keep the root path itself.
    const path = location.pathname.replace(/(.)\/+$/, '$1');
    const anyActive = NAV_ITEMS.some((item) => item.isActive(path));

    return (
        <header>
            <div className="navigation">
                <div className='logo'>
                    <img src={logo} alt='logo' />
                </div>
                <ul>
                    {NAV_ITEMS.map(({ to, label, Icon, isActive }) => (
                        <li key={to} className={isActive(path) ? 'list active' : 'list'}>
                            <Link to={to}>
                                <span className="icon"><Icon /></span>
                                <span className="text">{label}</span>
                            </Link>
                        </li>
                    ))}
                    <div className={anyActive ? 'indicator' : 'indicator hidden'}></div>
                </ul>
            </div>
        </header>
    );
};

export default Header;
